import type { Transition, Variants } from "motion/react";

export const ROUTE_CONTENT_ENTER_DURATION_S = 0.18;
export const ROUTE_CONTENT_EXIT_DURATION_S = 0.12;
export const ROUTE_CONTENT_OFFSET_PX = 8;

const EASE = [0.22, 1, 0.36, 1] as const;

/**
 * Route-content transition for the authenticated shell. The boundary sits above
 * `<main>`, outside every feature page, so no scroll container is transformed
 * and no ref is shared between the exiting and entering route.
 *
 * `pointerEvents: "none"` on exit keeps the outgoing route from intercepting
 * clicks while it fades, matching the conversation-switch pattern.
 */
export function routeContentMotion(reduceMotion: boolean): {
  variants: Variants;
  transition: Transition;
} {
  if (reduceMotion) {
    return {
      variants: {
        initial: { opacity: 1 },
        animate: { opacity: 1, pointerEvents: "auto" },
        exit: { opacity: 1, pointerEvents: "none" },
      },
      transition: { duration: 0 },
    };
  }

  return {
    variants: {
      initial: { opacity: 0, y: ROUTE_CONTENT_OFFSET_PX },
      animate: {
        opacity: 1,
        y: 0,
        pointerEvents: "auto",
        transition: { duration: ROUTE_CONTENT_ENTER_DURATION_S, ease: EASE },
      },
      exit: {
        opacity: 0,
        y: -ROUTE_CONTENT_OFFSET_PX / 2,
        pointerEvents: "none",
        transition: { duration: ROUTE_CONTENT_EXIT_DURATION_S, ease: EASE },
      },
    },
    transition: { duration: ROUTE_CONTENT_ENTER_DURATION_S, ease: EASE },
  };
}
